import React, { useRef } from "react";
import QRCode from "react-qr-code";
import styles from "./styles/About.module.css";
import googleplay from "../assets/images/googleplay.png";
import appstore from "../assets/images/appstore.png";
import { useLanguage } from "../LanguageContext";
import { motion, useInView } from "framer-motion";

function About({appLinks}) {
    const { t } = useLanguage();
    const titleRef = useRef(null);
    const isInView = useInView(titleRef, { once: true });

    return (
        <div className={styles.container}>
            <div className={styles.textBlock}>
                <h2>{t("about.heading")}</h2>
                <p dangerouslySetInnerHTML={{ __html: t("about.description") }} />
            </div>

            <div className={styles.aboutWrapper}>
                <span className={styles.aboutBtn}>{t("about.btn")}</span>
                <motion.h2
                    ref={titleRef}
                    className={styles.aboutBlockTitle}
                    initial={{ opacity: 0, y: 50 }}
                    animate={isInView ? { opacity: 1, y: 0 } : {}}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    {t("about.title")}
                </motion.h2>

                <p className={styles.aboutBlockSub}>{t("about.sub")}</p>

                <div className={styles.aboutBlockDivider}></div>

                <p className={styles.aboutBlockDesc}>{t("about.desc")}</p>

                <div className={styles.mobileApps}>
                    <a href={appLinks[1].url} target="_blank" rel="noopener noreferrer">
                        <img src={appstore} alt="App Store" />
                    </a>
                    <a href={appLinks[2].url} target="_blank" rel="noopener noreferrer">
                        <img src={googleplay} alt="Google Play" />
                    </a>
                </div>
                <div className={styles.qrCodeWrapper}>
                    <QRCode value={appLinks[0].url} className={styles.qr} fgColor={"#000"} bgColor={"#CFFB13"} />
                </div>
            </div>
        </div>
    );
}

export default About;
